import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  InputBase,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { httpsCallable } from "firebase/functions";
import { onAuthStateChanged } from "firebase/auth";

import {
  bgContainer,
  bodyContainer,
  container,
  itemText,
  searchContainer,
  searchInput,
  startButton,
  subContainer,
  tdItem,
  thItem,
} from "./styles";
import { colors } from "../../theme/colors";
import { isEmpty } from "../../utils";
import { showToast } from "../../services/toast";
import app, { auth, db, functions } from "../../services/firebase";
import { InspectionsType } from "../../types";
import { FirebaseError } from "firebase/app";

const Landing = () => {
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [inspections, setInspections] = useState<any[]>();
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLogin(true);
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  const texts = [
    "Web-based, mobile compliance app.",
    "Digital Vehicle Inspections.",
    "Digital Background Checks.",
    "No download required.",
  ];

  const handleSearch = async () => {
    if (isEmpty(searchText)) {
      showToast("Please input the vehicle number plate", "error");
      return;
    }
    setIsSearch(true);
    setIsLoading(true);
    const searchInspections = httpsCallable(functions, "searchInspections");

    searchInspections({ numberPlate: searchText })
      .then((result: any) => {
        setIsLoading(false);
        setInspections(result.data || []);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error instanceof FirebaseError) {
          showToast((error as FirebaseError).message, "error");
        } else {
          showToast("Unknown error", "error");
        }
      });
  };

  const handleDownload = (one: InspectionsType) => {
    if (!isLogin) {
      showToast(
        "You must create/login an account to download the report.",
        "error"
      );
      navigate("/");
    } else {
      // navigate(`/payments/${one.uid}?type=download`);
      console.log("download");
    }
  };

  return (
    <Box sx={(theme) => bodyContainer(theme)}>
      <Box sx={(theme) => subContainer(theme)}>
        <Box sx={(theme) => bgContainer(theme)} />
        <Box sx={(theme) => container(theme)}>
          {!isSearch && (
            <Box sx={{ marginTop: 5 }}>
              {texts.map((one, index) => {
                return (
                  <Typography sx={(theme) => itemText(theme)} key={index}>
                    {one}
                  </Typography>
                );
              })}
            </Box>
          )}
          {isSearch && (
            <Box
              sx={{
                mt: 5,
                borderRadius: "25px",
                width: "330px",
                p: "20px 10px",
                bgcolor: colors.main,
              }}
            >
              {!isLoading && inspections && inspections.length > 0 && (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 330 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={(theme) => thItem(theme)}>
                          Number Plate
                        </TableCell>
                        <TableCell align="center" sx={(theme) => thItem(theme)}>
                          Reprt Date
                        </TableCell>
                        <TableCell align="center" sx={(theme) => thItem(theme)}>
                          Make
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {inspections.map((one, index) => {
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell
                              align="center"
                              sx={(theme) => tdItem(theme)}
                            >
                              {one.numberPlate}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={(theme) => tdItem(theme)}
                            >
                              {one.inspectionDateString}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={(theme) => tdItem(theme)}
                            >
                              {one.make}
                            </TableCell>
                            <TableCell align="center" sx={{ p: "5px 0px" }}>
                              <Button
                                variant="contained"
                                sx={{
                                  p: "4px",
                                  bgcolor: colors.light_black,
                                  "&:hover": {
                                    backgroundColor: colors.light_black,
                                  },
                                  color: "white",
                                  fontSize: "11px",
                                }}
                                onClick={() => handleDownload(one)}
                              >
                                Download
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {!isLoading && (!inspections || inspections.length === 0) && (
                <Typography
                  sx={{
                    color: colors.light_black,
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  There is no inspection with this number plate
                </Typography>
              )}
              {isLoading && (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress color="secondary" />
                </Box>
              )}
            </Box>
          )}
          <Box sx={(theme) => searchContainer(theme)}>
            <SearchIcon color="disabled" />
            <InputBase
              placeholder="Search Vehicle Number Plate"
              sx={(theme) => searchInput(theme)}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Box>
          <Button
            variant="contained"
            sx={{
              bgcolor: colors.main,
              "&:hover": {
                backgroundColor: colors.main,
              },
              fontWeight: 500,
              mt: 3,
              width: "150px",
              height: "50px",
              fontSize: "18px",
              color: "white",
            }}
            onClick={() => {
              isLogin ? handleSearch() : navigate("/login");
            }}
          >
            Search
          </Button>
          <Button
            variant="contained"
            sx={(theme) => startButton(theme)}
            onClick={() => navigate("/services")}
          >
            Start
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Landing;
